import { render, staticRenderFns } from "./comment.html?vue&type=template&id=13a3b8cc&scoped=true&"
import script from "./comment.js?vue&type=script&lang=js&"
export * from "./comment.js?vue&type=script&lang=js&"
import style0 from "./comment.scss?vue&type=style&index=0&id=13a3b8cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a3b8cc",
  null
  
)

export default component.exports